import { useNavigate } from "react-router-dom-v5-compat";
import {
  IconNameEnum,
  useCheckoutStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreCheckoutComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { Icon, PageHeader } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./ConfirmationPageHeader.module.scss";

export interface PageHeaderComponentProps extends PlatformComponentProps {
  title?: string;
  subtitle?: string;
  closeOnClick?: () => void;
}

export const ConfirmationPageHeader = ({
  children,
  className,
  closeOnClick,
}: PageHeaderComponentProps) => {
  const COMPONENT_KEY = CoreCheckoutComponent.ConfirmationPageHeader;
  const styles = useCheckoutStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const navigate = useNavigate();

  return (
    <PageHeader className={clsx(block, className)}>
      <button
        onClick={() => (closeOnClick ? closeOnClick() : navigate("/"))}
        className={cn("close-button")}
      >
        <Icon iconName={IconNameEnum.close} />
      </button>
      {children}
    </PageHeader>
  );
};
